// extracted by mini-css-extract-plugin
var _1 = "AltLoginsForm-module__content___W3Ual";
var _2 = "AltLoginsForm-module__facebookIcon___KrW59";
var _3 = "AltLoginsForm-module__googleIcon___iyHVf";
var _4 = "AltLoginsForm-module__icon___o4MI8";
var _5 = "AltLoginsForm-module__socialButton___CdpCU";
export { _1 as "content", _2 as "facebookIcon", _3 as "googleIcon", _4 as "icon", _5 as "socialButton" }
